import React from 'react';
import './legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <div className="meta">Updated: October 4, 2025</div>
      <p><strong>Developer:</strong> IliaStasik (“we”, “our”, or “us”)</p>

      <p>IliaStasik develops and publishes mobile games, including StickBox and related titles (“Games”). This Privacy Policy explains how we collect, use, and protect your information when you use our Games or visit our website.</p>

      <p>IliaStasik is an alias and trade name operated by ILIA STASIK SERGEY, Individual Entrepreneur (IE), registered and located in Armenia, at the following address: 22A Nairi Zaryan Street, 0051, Yerevan, Armenia.</p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information:</p>
      <h3>a. Voluntarily Provided Information</h3>
      <ul>
        <li>Email address and account details you provide when registering or verifying your account.</li>
        <li>Any information you send to us when contacting support.</li>
      </ul>

      <h3>b. Automatically Collected Information</h3>
      <p>Our Games and website may use third-party analytics and advertising services that collect:</p>
      <ul>
        <li>Device information (device ID, operating system, model).</li>
        <li>IP address and approximate location.</li>
        <li>Gameplay events and app usage data.</li>
        <li>Advertising identifiers (such as Google Advertising ID or Apple IDFA).</li>
      </ul>
      <p>These services help us analyze performance, improve gameplay, and deliver personalized ads.</p>

      <h2>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Create and manage your player account.</li>
        <li>Send transactional emails (welcome, password reset, account verification).</li>
        <li>Improve gameplay experience and fix technical issues.</li>
        <li>Show relevant ads through third-party networks.</li>
        <li>Comply with legal obligations.</li>
      </ul>
      <p>We do not sell or rent your personal data to any third parties.</p>

      <h2>3. Third-Party Services</h2>
      <p>Our Games may include third-party SDKs or APIs from analytics and advertising providers. These partners may collect and process data in accordance with their own privacy policies.</p>
      <p>Common partners may include (but are not limited to):</p>
      <ul>
        <li>AdColony – <a href="https://www.adcolony.com/privacy-policy/">https://www.adcolony.com/privacy-policy/</a></li>
        <li>AppLovin – <a href="https://www.applovin.com/privacy/">https://www.applovin.com/privacy/</a></li>
        <li>Chartboost – <a href="https://answers.chartboost.com/en-us/articles/200780269">https://answers.chartboost.com/en-us/articles/200780269</a></li>
        <li>Facebook – <a href="https://www.facebook.com/about/privacy">https://www.facebook.com/about/privacy</a></li>
        <li>Fyber – <a href="https://www.fyber.com/privacy-policy/">https://www.fyber.com/privacy-policy/</a></li>
        <li>Google AdMob – <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a></li>
        <li>InMobi – <a href="https://www.inmobi.com/privacy-policy/">https://www.inmobi.com/privacy-policy/</a></li>
        <li>IronSource – <a href="https://developers.ironsrc.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/">https://developers.ironsrc.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/</a></li>
        <li>Mintegral – <a href="https://www.mintegral.com/en/privacy/">https://www.mintegral.com/en/privacy/</a></li>
        <li>Mopub – <a href="https://www.mopub.com/en/legal/privacy">https://www.mopub.com/en/legal/privacy</a></li>
        <li>Ogury – <a href="https://ogury.com/privacy-policy/">https://ogury.com/privacy-policy/</a></li>
        <li>Pangle – <a href="https://www.pangleglobal.com/privacy">https://www.pangleglobal.com/privacy</a></li>
        <li>Snap – <a href="https://snap.com/en-US/privacy/privacy-center">https://snap.com/en-US/privacy/privacy-center</a></li>
        <li>Tapjoy – <a href="https://www.tapjoy.com/legal/tapjoy-users/#privacy-policy">https://www.tapjoy.com/legal/tapjoy-users/#privacy-policy</a></li>
        <li>Unity Ads – <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a></li>
        <li>Verizon Media – <a href="https://www.verizonmedia.com/policies/xw/en/verizonmedia/privacy/intl/index.html">https://www.verizonmedia.com/policies/xw/en/verizonmedia/privacy/intl/index.html</a></li>
        <li>Vungle – <a href="https://vungle.com/privacy/">https://vungle.com/privacy/</a></li>
      </ul>

      <p>The app does use third party services that may collect information used to identify you. Link to privacy policy of third party service providers used by the app:</p>
      <ul>
        <li>Google Play Services: <a href="https://play.google.com/about/play-terms/">https://play.google.com/about/play-terms/</a></li>
        <li>Firebase: <a href="https://firebase.google.com/support/privacy">https://firebase.google.com/support/privacy</a></li>
        <li>Appodeal: <a href="https://appodeal.com/ccpa-privacy-policy/">https://appodeal.com/ccpa-privacy-policy/</a></li>
        <li>GameAnalytics: <a href="https://www.gameanalytics.com/trust/privacy-notice">https://www.gameanalytics.com/trust/privacy-notice</a></li>
      </ul>

      <h2>4. Data Retention and Deletion</h2>
      <p>We retain your personal data (such as your registration email) only for as long as necessary to provide the service. You can request account deletion at any time. When you do, we permanently delete your account, email address, and any associated personal data from our systems.</p>
      <p>To request deletion, please contact us at: <a href="mailto:isstasik@gmail.com">isstasik@gmail.com</a></p>

      <h2>5. Data Security</h2>
      <p>We take reasonable measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, please note that no method of transmission over the Internet or electronic storage is completely secure.</p>

      <h2>6. Children’s Privacy</h2>
      <p>Our Games are not directed to children under 13 years of age. We do not knowingly collect personal information from children under 13. If we learn that we have collected personal data from a child without parental consent, we will delete it immediately.</p>

      <h2>7. Your Rights</h2>
      <p>Depending on your location, you may have the right to:</p>
      <ul>
        <li>Access and receive a copy of your data.</li>
        <li>Request correction or deletion of your data.</li>
        <li>Object to or restrict processing of your data.</li>
      </ul>
      <p>You can exercise these rights by contacting us at the email above.</p>

      <h2>8. Updates to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. The latest version will always be available on our website.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions or concerns, contact us at: <a href="mailto:isstasik@gmail.com">isstasik@gmail.com</a></p>
      <p>Website: <a href="https://iliastasik.com">https://iliastasik.com</a></p>
    </div>
  );
}
